import { INPUT_MAXLENGTH } from '@/const/inputMaxLength';

/**
 * https://v2.ko.vuejs.org/v2/guide/custom-directive.html
 * directive api 문서
 */

export const directives = {
  maxlength: {
    // 직접 제한 숫자를 입력하거나, @/const/inputMaxLength 의 key를 입력하거나
    bind(el, { value }, vnode) {
      /**@type {HTMLInputElement} */
      const targetInput = el.querySelector('input[type="text"]');
      if (!targetInput) return;

      const maxlength = isNaN(+value) ? INPUT_MAXLENGTH[value] : +value;
      if (!maxlength) return;
      if (vnode.tag.includes('DirectInputSelect')) {
        vnode.componentInstance.maxlength = +maxlength;
      }

      targetInput.setAttribute('maxlength', maxlength);
    },
  },
};
